<template>
  <div>
    <div class="min-vh-100">
      <h1
        class="text-center text-sm-left mb-0 mb-sm-3 header-main text-uppercase header-inline"
      >
        CUSTOMER
      </h1>
      <div class="mt-3 bg-white-border p-3">
        <div>
          <b-row class="no-gutters my-3">
            <b-col lg="4">
              <!-- <b-input-group class="panel-input-serach">
                <b-form-input
                  class="input-serach"
                  placeholder="Social Name, Firstname, Lastname, Email"
                  @keyup="handleSearch"
                  v-model="filter.search"
                ></b-form-input>
                <b-input-group-prepend>
                  <span class="icon-input m-auto pr-2">
                    <font-awesome-icon icon="search" />
                  </span>
                </b-input-group-prepend>
              </b-input-group> -->
              <div>
                <b-input-group class="">
                  <b-form-input
                    v-model="filter.search"
                    placeholder="Social Name, Firstname, Lastname, Email"
                    @keydown.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button @click="handleSearch" class="search-button">
                      <font-awesome-icon icon="search" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
            <b-col lg="5">
              <b-dropdown
                id="dropdown-form"
                variant="outline"
                ref="dropdowndate"
                :text="dateType"
                class="bg-white p-0 pl-1 dropdown-date-custom w-100"
                menu-class="w-100"
              >
                <b-row class="no-gutters p-3">
                  <b-col class="dropdown-date-custom-text">
                    Select Date <span>(select only last 30 days)</span>
                  </b-col>
                  <!-- <b-col class="text-md-right" sm="6">
                  <a @click="resetDate"> Reset </a>
                </b-col> -->
                </b-row>
                <datetime
                  type="datetime"
                  v-model="filter.DateStart"
                  :min-datetime="minDate"
                  class="date-picker-input px-3"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                ></datetime>
                <div class="text-center">-</div>
                <datetime
                  type="datetime"
                  v-model="filter.DateEnd"
                  :min-datetime="minDate"
                  class="date-picker-input px-3"
                  value-zone="Asia/Bangkok"
                  placeholder="dd/mm/yyyy (hh:mm)"
                ></datetime>
                <div class="p-3">
                  <span class="text-danger" v-if="datetimeCheckError">{{
                    datetimeCheckError
                  }}</span>
                  <b-button
                    class="p-2 w-100 button-color"
                    size="sm"
                    @click="onClickChooseDate"
                    >SUBMIT</b-button
                  >
                </div>
              </b-dropdown>
            </b-col>
            <b-col xl="3" class="text-left text-xl-right">
              <b-button @click="exportExcel" class="export-button">
                <div>
                  <font-awesome-icon icon="file-export" />
                  <span class="ml-2"> EXPORT TO EXCEL </span>
                </div>
              </b-button>
            </b-col>
          </b-row>
          <b-row class="md-1 no-gutters my-3">
            <b-col class="mt-4 w-100">
              <b-table
                responsive
                striped
                hover
                class="table-list"
                :items="messageLists"
                :fields="fields"
                :busy="isBusy"
                show-empty
                empty-text="ไม่พบข้อมูล"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-black my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(createdTime)="data">
                  <span>
                    {{
                      new Date(data.item.createdTime) | moment($formatDateTime)
                    }}
                  </span>
                </template>
                <template v-slot:cell(registedTime)="data">
                  <span>
                    {{
                      new Date(data.item.registedTime) | moment($formatDateTime)
                    }}
                  </span>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="form-inline justify-content-center justify-content-sm-between"
            >
              <div v-if="rows > 0" class="my-auto">
                Showing {{ startPage }} to {{ endPage }} of {{ rows }} entires
              </div>
              <div v-else class="my-auto">{{ rows }} entire</div>
              <div class="d-sm-flex m-3">
                <b-pagination
                  v-model="filter.pageNo"
                  :total-rows="rows"
                  :per-page="filter.perPage"
                  class="m-md-0"
                  @change="pagination"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
        <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
        <ModalAlert
          ref="modalAlert"
          :text="modalMessage"
          v-on:hadleModalAlertClose="hadleModalAlertClose"
        />
        <ModalAlertError ref="modalAlertError" :text="modalMessage" />
      </div>
    </div>
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import moment from "moment";

export default {
  name: "MessageLog",
  components: {
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  data() {
    return {
      msgModal: null,
      modalMessage: "",
      minDate: moment(new Date()).subtract(1, "months").format(),
      startDate: "",
      isLoadingChannelType: false,
      dateType: "Select Date",
      endDate: "",
      datetimeCheckError: null,
      messageLists: [],
      messageChannels: [],
      statusCodeLists: [
        { value: 0, text: "All" },
        { value: 1, text: "Success" },
        { value: 2, text: "Fail" },
      ],
      messagePerSec: 0,
      mau: 0,
      isBusy: false,
      rows: 0,
      startPage: 1,
      endPage: 10,
      currentplan: 0,
      requestImage: 0,
      imageCount: 0,
      fields: [
        // {
        //   key: "id",
        //   label: "ID",
        //   class: "w-100px",
        // },
        {
          key: "socialName",
          label: "Social Name",
          class: "w-100px",
        },
        {
          key: "firstname",
          label: "Firstname",
          class: "w-100px",
        },
        {
          key: "lastname",
          label: "Lastname",
          class: "w-100px",
        },
        {
          key: "channelDisplay",
          label: "Channel",
          class: "w-100px",
        },
        {
          key: "scoreDisplay",
          label: "CSAT Score",
          class: "w-100px",
        },
        {
          key: "email",
          label: "Email",
          class: "w-100px",
        },
        {
          key: "registedTime",
          label: "Registed Time",
          class: "w-100px",
        },
        {
          key: "createdTime",
          label: "Created Time",
          class: "w-100px",
        },
        {
          key: "description",
          label: "Description",
          class: "w-100px",
        },
      ],
      filter: {
        pageNo: 1,
        perPage: 10,
        Search: "",
        DateStart: "",
        DateEnd: "",
      },
    };
  },
  created: async function () {
    this.getAllData();
    this.getShowingPage(1);
  },
  methods: {
    getAllData: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/Complain/GetComplain`, this.filter)
        .then((data) => {
          if (data.result === 1) {
            this.messageLists = data.detail.messageList;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getAllData();
      this.getShowingPage(Page);
    },
    getShowingPage(Page) {
      const totalRow = this.rows;
      this.startPage = (Page - 1) * this.filter.perPage + 1;
      if (Page * this.filter.perPage <= totalRow) {
        this.endPage = Page * this.filter.perPage;
      } else {
        this.endPage = totalRow;
      }
    },
    hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
    },
    async exportExcel() {
      this.$refs.modalLoading.show();
      const body = {
        ...this.filter,
      };

      await this.axios
        .post(`${this.$baseUrl}/Complain/ExportComplain`, body, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response]));
          var fileLink = document.createElement("a");
          var dateExcel = moment().format("DDMMYYYYhhmmss");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `Message Log -` + dateExcel + `.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getAllData();
      }
    },
    onClickChooseDate: async function () {
      if (this.filter.DateStart && this.filter.DateEnd) {
        this.datetimeCheckError = null;
        this.$refs.dropdowndate.hide(false);
        await this.getAllData();
        this.getShowingPage(1);
      } else {
        this.datetimeCheckError = "Please Choose Start and End";
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.break-all {
  word-break: break-all;
}

.textbody {
  width: 400px;
  word-break: break-all;
}

.submit-button {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}

.unit-font {
  font-size: 14px;
  color: #575757;
}

.container-borderleft {
  border-left: 5px solid #7160c4;
  background-color: #e2dff3;
}

.padding-rem {
  padding: 0.5rem 1.25rem;
}

.dropdown-date-custom {
  width: 60%;
  border-radius: 3px;
}

.dropdown-date-custom-text {
  color: #575757 !important;
}

.search-button {
  background-color: #ffffff;
  text-align: center !important;
  border-left: 0;
  color: #575757;
}

.button-color {
  background-color: #8f20c6;
  text-align: center !important;
  color: white;
}

.container-line {
  border-bottom: 1px solid #bebebe;
}

a {
  text-decoration: underline;
  color: #7160c4;
}

a:hover {
  cursor: pointer;
}

label {
  color: #8b8b8b;
}

.input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.overview-padding {
  padding: 16px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    padding: 16px 8px;
  }
}

.overview-number {
  font-size: 27px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    font-size: 24px;
  }
}

.overview-font-size {
  font-size: 16px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    font-size: 14px;
  }
}

.export-button {
  background-color: #0d1731;
  color: #ffffff !important;
  min-width: 150px;
  font-weight: bold;
  transition: 0.3s;
  border-radius: 4px;
  border-color: #0d1731;
}

.display-sm-none {
  @media screen and (max-width: 657px) {
    display: none;
  }
}

.header-inline {
  display: inline;
  @media screen and (max-width: 1200px) {
    display: block;
  }
}
</style>
